import axios from '@/libs/axios';
import { queryClient } from '@/libs/react-query';
import { useMutation } from '@tanstack/react-query'; //

//
export const balanceUpdate = data => {
  return axios.post('/account/changeAssets', data);
};
//
export const useBalanceUpdate = ({
  config
}) => {
  return useMutation({
    onSettled: () => {
      queryClient.invalidateQueries(['user-assets']);
    },
    mutationFn: balanceUpdate,
    ...config
  });
};